const actions = {
  GET_ANNOUNCEMENT: "GET_ANNOUNCEMENT",
  GET_ANNOUNCEMENT_SUCCESS: "GET_ANNOUNCEMENT_SUCCESS",
  GET_ANNOUNCEMENT_FAILED: "GET_ANNOUNCEMENT_FAILED",

  ADD_ANNOUNCEMENT: "ADD_ANNOUNCEMENT",
  ADD_ANNOUNCEMENT_SUCCESS: "ADD_ANNOUNCEMENT_SUCCESS",
  ADD_ANNOUNCEMENT_FAILED: "ADD_ANNOUNCEMENT_FAILED",

  DELETE_ANNOUNCEMENT: "DELETE_ANNOUNCEMENT",
  DELETE_ANNOUNCEMENT_SUCCESS: "DELETE_ANNOUNCEMENT_SUCCESS",

  RESET_ANNOUNCEMENT: "RESET_ANNOUNCEMENT",
  RESET_ANNOUNCEMENT_MESSAGE: "RESET_ANNOUNCEMENT_MESSAGE",

  PREPARE_ANNOUNCEMENT_FORM: "PREPARE_ANNOUNCEMENT_FORM",

  getAnnouncement: () => ({
    type: actions.GET_ANNOUNCEMENT,
  }),
  getAnnouncementSuccess: (announcementResult) => ({
    type: actions.GET_ANNOUNCEMENT_SUCCESS,
    announcementResult,
  }),
  getAnnouncementFailed: (announcementError) => ({
    type: actions.GET_ANNOUNCEMENT_FAILED,
    announcementError,
  }),

  prepareAnnouncementForm: () => ({
    type: actions.PREPARE_ANNOUNCEMENT_FORM,
  }),

  addAnnouncement: (data) => ({
    type: actions.ADD_ANNOUNCEMENT,
    payload: { data },
  }),
  addAnnouncementSuccess: (announcementMessage, announcementResult) => ({
    type: actions.ADD_ANNOUNCEMENT_SUCCESS,
    announcementMessage,
    announcementResult,
  }),
  addAnnouncementFailed: (announcementError) => ({
    type: actions.ADD_ANNOUNCEMENT_FAILED,
    announcementError,
  }),

  deleteAnnouncement: (announcementId, status) => ({
    type: actions.DELETE_ANNOUNCEMENT,
    payload: { announcementId, status },
  }),
  deleteAnnouncementSuccess: (announcementMessage, announcementResult) => ({
    type: actions.DELETE_ANNOUNCEMENT_SUCCESS,
    announcementMessage,
    announcementResult,
  }),

  resetAnnouncement: () => ({
    type: actions.RESET_ANNOUNCEMENT,
  }),

  resetAnnouncementMessage: () => ({
    type: actions.RESET_ANNOUNCEMENT_MESSAGE,
  }),
};
export default actions;
